import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { backendPagination } from '../../../app/app-constant';
import { TagsService } from '../../services/tags.service';

@Component({
  selector: 'app-filter-table',
  templateUrl: './filter-table.component.html',
  styleUrls: ['./filter-table.component.css'],
  //encapsulation: ViewEncapsulation.None
})
export class FilterTableComponent implements OnInit {

  showFilterContent: boolean = false;
  @Input() cols;
  rangeValues: number[] = [20,80];
  activeIndex = 0;
  @Output() filterEvent: any  = new EventEmitter();
  applyedFilterStr: String = 'Filter by';
  appliedFilter: any = [];
  backendPagination = backendPagination;
  activeCheckboxCol: any;
  columnNameElemList = [];

  constructor(private tagsService: TagsService) { }

  ngOnInit() {
    //console.log(this.cols, JSON.stringify(this.cols));
  }

  onClickOutside(event: any) {
    //console.log(event);
    if(event && event['value'] === true && ['pi pi-chevron-right', 'pi pi-chevron-left'].indexOf(event.target.className) == -1 ) {
      this.showFilterContent = false;
    } else {
      //console.log('clicked inside');
    }
  }

  toggleFilterContent() {
    this.showFilterContent = !this.showFilterContent;
    this.tagsService.link({
      "event_action" : "dropdown",
      "event_content": "filter by : " + this.showFilterContent ? "expand" : "collapse"
    });
  }

  filterSearch(event, columnName) {console.log(columnName);
    this.tagsService.link({
      "event_action" : "dropdown",
      "event_content": "filter by : " + columnName + " : search : text entered"
    });
  }

  filter() {
    //this.applyedFilterStr = '';
    //console.log(JSON.stringify(this.cols));
    // if(!backendPagination) {
      this.appliedFilter = [];
    // }
    
    for(const col of this.cols) {
      if(col.selectedValue 
        && col.selectedValue.length != 0 
        && (col.filterType != 'date' 
          || (col.filterType == 'date' 
            && (col.selectedValue.fromDate || col.selectedValue.toDate)
            )
          )
        && (col.filterType != 'range' 
          || (col.filterType == 'range' 
            && !(col.selectedValue[0] == col.originalValues[0] 
              && col.selectedValue[1] == col.originalValues[1]
              )
            )
          )
        ) {
          //this.applyedFilterStr += this.applyedFilterStr ? ', '+col.header : col.header;
          for(const key in this.appliedFilter) {
            if(this.appliedFilter[key].field == col.field) {
              this.appliedFilter.splice(key, 1);
            }
          }

          if(col.filterType == 'range') {
            col.selectedValue[0] = typeof col.selectedValue[0] == 'string' ? parseFloat(col.selectedValue[0].replace(/,/g, '')) : col.selectedValue[0];
            col.selectedValue[1] = typeof col.selectedValue[1] == 'string' ? parseFloat(col.selectedValue[1].replace(/,/g, '')) : col.selectedValue[1];
          }
          this.appliedFilter.push(Object.assign({}, col));
          //console.log(col);
      }
    }
    this.filterEvent.next(this.appliedFilter);

    this.tagsService.link({
      "event_action" : "button click",
      "event_content": "filter by : filter"
    });
  }

  clear() {
    this.applyedFilterStr = 'Filter by';
    this.filterEvent.next([]);
    for(const col of this.cols) {
      col.selectedValue = col.filterType == "check-box" ? [] : (col.filterType == "range" ? [col.originalValues[0], col.originalValues[1]] : (col.filterType == "string" ? '' : (col.filterType == "date" ? {} : null)));
      col.enabled = true;
    }
    
    this.appliedFilter = [];

    this.tagsService.link({
      "event_action" : "button click",
      "event_content": "filter by : reset"
    });
  }

  clearColumnFilter(index: any) {
    //console.log(this.appliedFilter[index]);
    for(const col of this.cols) {
      if(col.header == this.appliedFilter[index].header) {
        col.selectedValue = col.filterType == 'check-box' ? [] : (col.filterType == 'date' ? {} : [col.originalValues[0], col.originalValues[1]]);
        this.updateEnableCol(col);
      }
    }

    this.appliedFilter.splice(index, 1);
    this.filterEvent.next(this.appliedFilter);

    this.tagsService.link({
      "event_action" : "button click",
      "event_content": "applied filter : clear icon"
    });
  }

  dateFormat(inputDate: any) {
    const date = inputDate.toString();
    if(date.indexOf('-') > -1) {
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      return date.split(' ')[0].split('-')[2]+' '+months[date.split(' ')[0].split('-')[1]-1]+' '+date.split(' ')[0].split('-')[0];
    } else {
      return date.split(' ')[2]+' '+date.split(' ')[1]+' '+date.split(' ')[3];
    }
  }

  updateEnableCol(colData) {
    for(const col of this.cols) {
      if(colData.filterField == col.filterField && colData.field != col.field) {
        if(colData.selectedValue.length) {
          col.enabled = false;
        } else {
          col.enabled = true;
        }
      }
    }

    this.tagsService.link({
      "event_action" : "checkbox",
      "event_content": "filter by : " + colData.header + " : checkbox : selected"
    });
  }

  moveColumnFocus(event) {
    const activeEle: any = document.activeElement;
    //const activeEleIndex = Array.prototype.indexOf.call(this.columnNameElemList, activeEle);
    if(event.key == "ArrowDown") {
      activeEle.nextElementSibling.focus();
    } else if(event.key == "ArrowUp") {
      activeEle.previousElementSibling.focus();
    } if(event.key == "ArrowRight") {
      activeEle.parentElement.nextElementSibling.focus();
    }
  }

  moveFocus(event, focusData) {
    const activeEle: any = document.activeElement;

    if(["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].indexOf(event.key) > -1) {
      if(focusData[event.key]) {console.log(focusData[event.key]);
        switch(focusData[event.key]) {
          case 'filter-columns':
            let columnTab: any = document.getElementsByClassName('filter-columns')[0].getElementsByTagName('li')[0];
            columnTab.focus();
            break;
          case 'column-values':
            let columnValues: any = activeEle.parentElement.previousElementSibling.focus();
            columnValues.focus();
            break;
          case 'close-button':
            let closeButton: any = document.getElementById('close-button');
            closeButton.focus();
            break;
          case 'filter-button':
            let filterButton: any = document.getElementById('filter-button');
            filterButton.focus();
            break;
        }
      }
    }
  }

  omitSpecialChar(event){
    var k = event.charCode;
    return ((k > 47 && k < 58) || k == 44 || k == 46);
  }

}
